<template class="container">
    <h1 class="mt-5">Path Loss Exponent Calculator</h1>
    <CalculatorComponent />
      
</template>
  
<script>
import CalculatorComponent from '../components/calculator.vue'

export default {
    name: 'HomePage',
    components: {
        CalculatorComponent
    }
}

</script>
